

const ms255 = {
  label: "Deposit Exclude Interest Paid",
  pageLabel: "Deposit Exclude Interest Paid",
  starting: true,
  url: "ms255",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "branch",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "branch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "product",
      description: "Enter 2 digit branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "product",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account Number",
      label: "Account Number",
      name: "",
      description: "Account Number"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Account Number-1",
          value: "Account Number-1"
        },
        {
          label: "Account Number-2",
          value: "Account Number-2"
        },
        {
          label: "Account Number-3",
          value: "Account Number-3"
        }
      ],
      placeHolder: "Account Number",
      //   label: "Branch Code",
      name: "accountNumber",
      description: "Enter Account Number"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "accountNumber",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Last Transaction Date",
      label: "Last Transaction Date",
      name: "",
      description: "Last Transaction Date"
    },
    {
      inputType: "date",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Last Transaction Date",
      name: "LastTransactionDate",
      description: "Last Transaction Date"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Interest",
      label: "Interest",
      name: "",
      description: "Enter Interest"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Enter Interest",
      label: "",
      name: "Interest",
      description: "Enter Interest"
    }
  ]
};

export default ms255;
